const schema = () => ({
  type: 'object',
  // title: 'اطلاعات اصلی',
  required: [],
  properties: {
    title: {
      title: 'عنوان',
      type: 'string',
    }
  },
});

export default schema;
